import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=4b9c6a98&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"
import style0 from "./Success.vue?vue&type=style&index=0&id=4b9c6a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c6a98",
  null
  
)

export default component.exports